import { Password } from '@mui/icons-material';
import { config } from '../config';
import { makeApiRequest_AppJson, makeApiRequest_formData } from './common-apiService';

// TEMPLATES

export const fetchTemplates = async (accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const createTemplate = async (accessToken, templateDTO) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, templateDTO);
}

export const updateTemplate = async (accessToken, templateId, templateDTO) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/${templateId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, templateDTO);
}

export const deleteTemplate = async (accessToken, templateId) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/${templateId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const fetchTemplateAllInstances = async (accessToken, templateId) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/${templateId}/allInstances`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchTemplateInstancesFromOrganization = async (accessToken, templateId) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/${templateId}/instances`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const uploadTemplateImage = async (accessToken, templateId, imageFile) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/${templateId}/image`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    const formData = new FormData();
    formData.append('image', imageFile);
    return makeApiRequest_formData(url, 'POST', headers, formData);
}

export const deleteRelatedTemplateImage = async (accessToken, templateId) => {
    const url = `${config.baseB2B_URL}/b2b/social/templates/${templateId}/image`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// TEMPLATE INSTANCES (POSTS)

export const createTemplateInstance = async (accessToken, socialPostTemplateId, newPostInstanceDTO) => {
    const url = `${config.baseB2B_URL}/b2b/social/instances/${socialPostTemplateId}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, newPostInstanceDTO);
}

export const fetchOrganizationInstances = async (accessToken, organizationUUID) => {
    const url = `${config.baseB2B_URL}/b2b/social/instances//+by-organization/${organizationUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchInstance = async (accessToken, socialPostInstanceId) => {
    const url = `${config.baseB2B_URL}/b2b/social/instances/${socialPostInstanceId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const updateInstance = async (accessToken, socialPostInstanceId, instanceDTO) => {
    const url = `${config.baseB2B_URL}/b2b/social/instances/${socialPostInstanceId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, instanceDTO);
}

export const deleteInstance = async (accessToken, socialPostInstanceId) => {
    const url = `${config.baseB2B_URL}/b2b/social/instances/${socialPostInstanceId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// PUBLIC POSTS

export const fetchPublicPostInfo = async (postId) => {
    const url = `${config.baseB2B_URL}/b2b/social/public/${postId}/info`;
    return makeApiRequest_AppJson(url, 'GET');
}

export const fetchPublicPost = async (postId, password = null) => {
    const url = `${config.baseB2B_URL}/b2b/social/public/${postId}`;
    const headers = {};
    if (password) {
        headers['X-B2B-SOCIAL-KEY'] = password;
    }
    return makeApiRequest_AppJson(url, 'GET', headers);
}

// GIT

export const fetchGitSocialData = async () => {
    const url = `${config.baseB2B_URL}/b2b/social/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};
